import { render, staticRenderFns } from "./creat-video.vue?vue&type=template&id=69e97885&scoped=true"
import script from "./creat-video.vue?vue&type=script&lang=js"
export * from "./creat-video.vue?vue&type=script&lang=js"
import style0 from "./creat-video.vue?vue&type=style&index=0&id=69e97885&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e97885",
  null
  
)

export default component.exports